import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE, IF_ANY } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Padlock Access</PageHeader>

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMAccessPadlock} label="✨ Enhance with AI" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccess,"1")}/>
        <TextRow {...page}  hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.LLMAccessPadlock,"1"),IS_NOT_EQUAL(LocationVarKey.LLMisAccess,"1")])}>
            <div className="rainbowPower">
            Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your knowledge graph.
            </div>
        </TextRow>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasPadlocks,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.FeaturePadlocks1}
        />
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasPadlocks,"1")}
            marginTop
            label=" Message 2"
            keyName= {LocationVarKey.FeaturePadlocks2}
        />

        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration,"1")} >Delivery Settings</SectionHeader>
        <DropdownRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration,"1")}
        marginTop
        label=" Send DaVinci Code to:"
        keyName= {LocationVarKey.DaVinciCodeDeliveryChannel}
        options={[
            {
                label:"SMS",
                value:"SMS"
            },
            {
                label:"Email",
                value:"Email"
            },
            {
                label:"SMS and Email",
                value:"Both"
            }
        ]} />
        <TextAreaRow {...page}   hideIf={IS_EQUAL(LocationVarKey.DaVinciCodeDeliveryChannel,"Email") && IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration,"1")}
            marginTop
            label=" SMS Message"
            keyName= {LocationVarKey.DaVinciCodeSMSMessage}
        />

    </>
}